import { render, staticRenderFns } from "./UserRegisterPackageHistory.vue?vue&type=template&id=bd4f78de&scoped=true"
import script from "./UserRegisterPackageHistory.vue?vue&type=script&lang=js"
export * from "./UserRegisterPackageHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd4f78de",
  null
  
)

export default component.exports